import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { isViewingAsVisitor } from '../../../../selectors/users';
import { getActiveSection } from '../../../../selectors/sections';
import { viewProfileAsVisitor } from '../../../../actions/profileOwner';
import { Props } from './SubNavBarDesktopInner';

type StateProps = Pick<Props, 'canViewAsVisitor'>;
type DispatchProps = Pick<Props, 'viewAsVisitor'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  canViewAsVisitor:
    !isViewingAsVisitor(state) && getActiveSection(state) !== 'stats',
  isViewingAsVisitor: isViewingAsVisitor(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  viewAsVisitor: viewProfileAsVisitor,
};

export default connect(mapStateToProps, mapDispatchToProps);
